document.addEventListener('DOMContentLoaded', function () {
  var headerWrapper = document.querySelector('.header-wrapper');
  if (!headerWrapper) return;

  var onScroll = function () {
    if (window.scrollY > 12) {
      headerWrapper.classList.add('is-scrolled');
    } else {
      headerWrapper.classList.remove('is-scrolled');
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
});
